export default __webpack_public_path__ + "static/media/Ballroll_00063.428363ba.png";